import Analysis from 'domain/entity/analysis';
import ReadAnalysisCriteria from 'use-case/analysis/read/readAnalysisCriteria';
import { getApiClient } from 'adapter/out/client/apiClient';
import { parseJsonAnalysis } from 'adapter/out/client/analysis/parseAnalysis';

const getReadAnalysisApiClient = getApiClient(
    (criteria: ReadAnalysisCriteria) => `dashboards/analyses/${criteria.analysisId}`,
    Analysis,
    undefined,
    parseJsonAnalysis
);

export default getReadAnalysisApiClient;
